var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTriangleExclamation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 4c1.775 0 3.413.938 4.313 2.475l27 46c.912 1.55.912 3.462.025 5.013S60.788 60 59 60H5c-1.788 0-3.45-.963-4.338-2.513s-.875-3.475.025-5.013l27-46A4.99 4.99 0 0 1 32 4m0 16c-1.663 0-3 1.337-3 3v14c0 1.663 1.337 3 3 3s3-1.337 3-3V23c0-1.663-1.337-3-3-3m4 28a4 4 0 1 0-8 0 4 4 0 1 0 8 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleExclamation);
export default __webpack_public_path__ + "static/media/triangle-exclamation.425282b3c86d14d6d6f31a27475dfd86.svg";
export { ForwardRef as ReactComponent };